import React, { FC } from 'react'
import {
  IconBrandInstagram,
  IconBrandMeta,
  IconBrandFacebook,
  IconBrandSnapchat,
  IconBrandGoogle,
  IconBrandReddit,
  IconBrandYoutube,
  IconBrandTiktok,
  IconBrandSpotify,
  IconX,
} from '@tabler/icons-react'

interface ChannelIconProps {
  readonly channel:
    | 'googleDisplay'
    | 'snapchat'
    | 'instagram'
    | 'youtube'
    | 'tiktok'
    | 'meta'
    | 'facebook'
    | 'spotify'
    | 'reddit'
    | 'twitter'
  readonly size?: string | number
  readonly color?: string
}

const RenderChannelIcon: FC<ChannelIconProps> = ({ channel, size = 16, color = '#fff' }) => {
  switch (channel) {
    case 'googleDisplay':
      return <IconBrandGoogle size={size} color={color} fill={color} stroke={color} />
    case 'snapchat':
      return <IconBrandSnapchat size={size} color={color} />
    case 'instagram':
      return <IconBrandInstagram size={size} color={color} />
    case 'youtube':
      return <IconBrandYoutube size={size} color={color} />
    case 'tiktok':
      return <IconBrandTiktok size={size} color={color} stroke={color} strokeWidth={2} />
    case 'meta':
      return <IconBrandMeta size={size} color={color} strokeWidth={2} />
    case 'facebook':
      return <IconBrandFacebook size={size} color={color} fill={color} stroke={color} />
    case 'spotify':
      return <IconBrandSpotify size={size} color={color} />
    case 'reddit':
      return <IconBrandReddit size={size} color={color} stroke={color} strokeWidth={2} />
    case 'twitter':
      return <IconX size={size} color={color} fill={color} stroke={color} strokeWidth={2} />
    default:
      return <></>
  }
}

export default RenderChannelIcon
